import MuiButton from '@material-ui/core/Button';

class Button extends React.Component {
  propsForVariant = () => {
    const { variant } = this.props;

    switch (variant) {
      case 'primary':
        return {
          variant: 'contained',
          color: 'primary',
        };
      case 'secondary':
        return {
          variant: 'text',
        };
      case 'circular':
        return {
          variant: 'fab',
          color: 'primary',
        };
      default:
    }
  };

  render() {
    const { variant: _variant, ...props } = this.props;
    const muiProps = this.propsForVariant();

    return <MuiButton {...props} {...muiProps} />;
  }
}

export default Button;
